import React from 'react';

/* A polaroid: white frame, tilted, name written under the photo. */
export function FounderCard({
    name,
    role,
    photo,
    linkedin,
}: {
    name: string;
    role: string;
    photo: string;
    linkedin: string;
}) {
    return (
        <div className="ds-polaroid">
            <img className="ds-polaroid__photo" src={photo} alt={name} loading="lazy" decoding="async" />
            <div className="ds-polaroid__cap">
                <span className="ds-polaroid__name">{name}</span>
                <span className="ds-polaroid__role">{role}</span>
                <a className="ds-polaroid__link" href={linkedin} target="_blank" rel="noreferrer">
                    LinkedIn
                    <svg width="11" height="11" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                        <path d="M4.5 11.5 11.5 4.5M5.5 4.5h6v6" />
                    </svg>
                </a>
            </div>
        </div>
    );
}
